import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from 'src/material.module';
import { DefaultLayoutComponent } from 'src/components/default-layout/default-layout.component';
import { PeoplesComponent } from './peoples/peoples.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ContentComponent } from './content/content.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { SavePeopleComponent } from './save-people/save-people.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { LoaderPopComponent } from 'src/components/loader-pop/loader-pop.component';
import { MessagePopComponent } from 'src/components/message-pop/message-pop.component';
import {
  ModalModule,
} from "angular-bootstrap-md";
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { AuthenticationComponent } from './authentication/authentication.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ProfileComponent } from './profile/profile.component';
import { UpdateAdminComponent } from './update-admin/update-admin.component';
import { DemographicDataComponent } from './demographic-data/demographic-data.component';
import { BannersComponent } from './banners/banners.component';
import { ResourcesComponent } from './resources/resources.component';
import { LanguagesComponent } from './languages/languages.component';
import { LanguageDetailComponent } from './language-detail/language-detail.component';
import { QuillModule } from 'ngx-quill';
@NgModule({
  declarations: [
    AppComponent,
    DefaultLayoutComponent,
    LoaderPopComponent,
    MessagePopComponent,
    PeoplesComponent,
    ContentComponent,
    AnalyticsComponent,
    SavePeopleComponent,
    LoginComponent,
    ForgotPasswordComponent,
    AuthenticationComponent,
    ResetPasswordComponent,
    ProfileComponent,
    UpdateAdminComponent,
    DemographicDataComponent,
    BannersComponent,
    ResourcesComponent,
    LanguagesComponent,
    LanguageDetailComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialModule,
    FormsModule,
    ModalModule.forRoot(),
    ReactiveFormsModule,
    HttpClientModule,
    QuillModule.forRoot()
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'en-GB' }],
  bootstrap: [AppComponent]
})
export class AppModule { }
